// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".strength[data-v-e2c14940]{border-left-color:#33a79d}.strength[data-v-e2c14940],.weakness[data-v-e2c14940]{border-left-width:10px!important}.weakness[data-v-e2c14940]{border-left-color:#eee}", ""]);
// Exports
module.exports = exports;
